<template>
    <b-modal :id="modal_id" :title="title" size="xl">

        <b-overlay :show="loading">
            <div v-if="!error">
                <iframe ref="orderingPolicies" :src="src" class="w-100" height="800px"></iframe>
            </div>
            <b-alert v-else show>{{ error }}</b-alert>
        </b-overlay>
        <template v-slot:modal-footer="{ ok, cancel, hide }"></template>

    </b-modal>
</template>

<script>

  import Document from "../../../models/Document";

  export default {
    name: 'OrderFormPolicyModal',
    props: ['modal_id'],
    data() {
      return {
        title: 'Order Form Policies',
        loading: true,
        document: null,
        src: null
      };
    },
    methods: {
      init() {
        this.loading = true;
        return this.fetch().then(() => {
          return this.populate().then(() => {
            this.error = null;
            this.loading = false;
          }, this.defaultError);
        }, this.defaultError);
      },
        fetch() {
          return new Promise((resolve, reject) => {
            return Promise.all([
              Document.api().fetch({name: 'Ordering Policies'}),
            ]).then((results) => {
              let document_results = results[0];
              if(document_results.entities.documents && document_results.entities.documents.length) {
                this.document = document_results.entities.documents[0];
                return resolve(this.document);
              } else {
                return reject();
              }
            }, () => {
              return reject();
            });
          });
        },
      populate() {
        let p = [Document.api().file(this.document.id, this.document.mime_type)];
        return Promise.all(p).then((responses) => {
          let urlCreator = window.URL || window.webkitURL;
          let document_response = responses[0];
          let document_data = document_response.response.data;
          let document_type = this.document.mime_type;
          let document_file = new Blob([document_data], {type: document_type});
          this.src = urlCreator.createObjectURL(document_file);
        });
      },
      defaultError(err) {
        this.loading = false;
        return this.error = 'The order form policies are not available at this moment, please try again later.';
      },
    },
    mounted() {
      this.init();
    }
  }
</script>
